module.exports = __webpack_public_path__ + "img/login-bg-10.e33d2f2f.jpg";